import React from 'react'
import { Card, Col, Row, Container, Image, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
export default function Clients() {
  return (
    <section className='section-4 section'>
        <Row>
          <Col lg={6}>
            <div className='clent-logo-box section-45'>
              <h5 className='sub-heading'>Clients</h5>
              <h1 className='title-heading'>
                Amazing Clients <br />Amazing Requirnments
              </h1>
              <div className='clent-logo-img-box'>
                <Row>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                      <img src={require('../assets/images/clients/1.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/2.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/3.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/4.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/5.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/6.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/7.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/8.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/9.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/10.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/11.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/clients/12.png')} alt="c-1" />
                    </Card>
                  </Col>
                </Row>
                <div className='view-all-logo-box'>
                  <Link to="/clients">View All</Link>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6}>
            <div className='clent-logo-box section-45'>
              <h5 className='sub-heading'>Affiliations</h5>
              <h1 className='title-heading'>
                National and <br />International Affiliations
              </h1>
              <div className='clent-logo-img-box clent-logo-img-box-right'>
                <Row >
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/affiliations/1.png')} alt="c-1" />
                    </Card>
                  </Col>

                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/affiliations/3.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/affiliations/4.png')} alt="c-1" />
                    </Card>
                  </Col>

                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/affiliations/6.png')} alt="c-1" />
                    </Card>
                  </Col>

                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/affiliations/2.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/affiliations/5.png')} alt="c-1" />
                    </Card>
                  </Col>
                  <Col lg={3} md={3} sm={6}>
                    <Card>
                    <img src={require('../assets/images/affiliations/7.png')} alt="c-1" />
                    </Card>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </section>
  )
}
